import { Flex, theme } from 'antd'
import { Flag } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useIconSizes } from 'src/hooks'

import type { TicketPriority } from '../../types'

type Props = {
  priority: number | null
}

export const PRIORITY_LABEL_KEYS: Record<TicketPriority, string> = {
  1: 'tickets.priority.urgent',
  2: 'tickets.priority.high',
  3: 'tickets.priority.normal',
  4: 'tickets.priority.low'
}

export const PriorityLabel = ({ priority }: Props) => {
  const { small: iconSize } = useIconSizes()
  const { token } = theme.useToken()
  const { t } = useTranslation()

  if (!priority) return '—'

  const colors: Record<TicketPriority, string> = {
    1: token.colorError,
    2: token.colorWarning,
    3: token.colorInfo,
    4: token.colorTextTertiary
  }
  const color = colors[priority as TicketPriority]
  const label = t(PRIORITY_LABEL_KEYS[priority as TicketPriority])

  return (
    <Flex component="span" align="center" gap={token.marginXXS}>
      <Flag
        size={iconSize}
        strokeWidth={1.5}
        color={color}
        fill={color}
        aria-hidden
      />
      {label}
    </Flex>
  )
}
